import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router';

export function withRouter(Component) {
    return function Wrapper(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        return (
            <Component
                {...props}
                location={location}
                navigate={navigate}
                params={params}
            />
        );
    };
}
